import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  HeadObject: {
    A_VocTyp: "",
    A_VocTypName: "",
    A_VocNo: "",
    A_PostDt: new Date(), // dd/MM/yyyy
    A_ReceiptDt: new Date(), // dd/MM/yyyy
    A_Loc: "",
    A_LocName: "",
    A_DocStat: "ENTER",
    Driver: "",
  },
};

const SliceTransDetailReport = createSlice({
  name: "SliceTransDetailReport",
  initialState: { value: initialState },

  reducers: {
    //including   RESET ALL
    Set_TransDetailReport_Init: (state) => {
      state.value = initialState;
    },

    //RESET HEAD
    Set_TransDetailReport_HeadObject_Init: (state) => {
      state.value.HeadObject = initialState.HeadObject;
    },

    Set_TransDetailReport_HeadObject_Set: (state, action) => {
      state.value.HeadObject = action.payload;
    },
  },
});

export const {
  Set_TransDetailReport_Init,
  Set_TransDetailReport_HeadObject_Set,
  Set_TransDetailReport_HeadObject_Init,
} = SliceTransDetailReport.actions;
export default SliceTransDetailReport.reducer;
